import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue';
import { Icon } from '../../Atoms';


export default /*@__PURE__*/_defineComponent({
  __name: 'ScrollToTop',
  setup(__props) {

const triggeredByKeyboard = ref(false);
const handleKeydown = (event: KeyboardEvent) => {
  if (event.key === 'Enter' || event.key === ' ') {
    triggeredByKeyboard.value = true;
  }
};
const scroll = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
  if (triggeredByKeyboard.value) {
    setTimeout(() => {
      const input = document.getElementById('serviceStatusInput') as HTMLElement | null;
      if (input) {
        input.focus();
      }
    }, 300);
    triggeredByKeyboard.value = false;
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "back-to-top",
    onClick: _cache[0] || (_cache[0] = () => scroll()),
    onKeydown: handleKeydown
  }, [
    _createTextVNode(_toDisplayString(_ctx.$t('Back to top')) + " ", 1),
    _createVNode(_unref(Icon), { "icon-name": "arrowUp" })
  ], 32))
}
}

})